import { createContext } from 'react';

import type { StorefrontTheme } from '@/features/storefront/themeSchema';

/**
 * The theme the shell is actually rendering, for the pages inside it.
 *
 * Usually that is the published theme, and a page could have read it from the
 * context query it is already cached in. It is not always: a merchant in
 * preview is walking through their real shop wearing a theme that is not
 * published, and a listing page that went to the query cache would lay itself
 * out for the wrong one - a preview that disagrees with itself page to page.
 *
 * Separate from the provider so the shell can export a component and this can
 * export a context without the two sharing a module.
 */
export const StorefrontThemeContext = createContext<StorefrontTheme | null>(null);
